/**
 * 運営事務向け 全マスタ一覧・物理削除の型定義（#3254）
 */

/** Firestore 上の状態 */
export const masterFirestoreState = {
  /** Firestore に有効なドキュメントが存在する（物理削除不可） */
  active: 'active',
  /** Firestore で論理削除済み（status=99）。物理削除可 */
  deleted: 'deleted',
  /** Firestore に対応ドキュメントが存在しない（登録途中失敗の残骸）。物理削除可 */
  orphan: 'orphan',
  /** Cloud SQL から物理削除済み。Firestore に status=99 の記録だけが残っている */
  purged: 'purged',
} as const;

export type MasterFirestoreState = (typeof masterFirestoreState)[keyof typeof masterFirestoreState];

export interface MasterDatasetRow {
  master_dataset_id: number;
  gendrive_company_id: string;
  company_name: string | null;
  file_name: string | null;
  search_key: string | null;
  record_count: number;
  field_mapping_count: number;
  match_history_count: number;
  created_at: string;
  firestore_state: MasterFirestoreState;
  master_id: string | null;
  deletable: boolean;
}

export interface ListAllMasterDatasetsResponse {
  status: 'ok';
  datasets: MasterDatasetRow[];
}

export interface DeleteMasterDatasetRequest {
  master_dataset_id: number;
}

export interface DeleteMasterDatasetResponse {
  status: 'ok';
  deleted_records: number;
  deleted_field_mappings: number;
  deleted_match_histories: number;
  deleted_csv_job_histories: number;
}
